import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import {
  EMAIL_VALIDATION_PATTERN,
  MSG_CONGRATS_PARKING,
  MULTILINGUAL_NAME_VALIDATION_PATTERN,
  logo,
} from '@shared/constant/shared.constant';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input-gg';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { CommonFunctions } from '@shared/common-functions';
import { CongratsModalComponent } from './congrats-modal/congrats-modal.component';
import { OnboardingServiceService } from '@core/services/onboarding-service.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { ConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnBoardingComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  ingredient!: string;
  logo: string = logo;
  ownerForm: FormGroup;
  separateDialCode = false;
  searchCountryField = SearchCountryField;
  countryISO = CountryISO;
  phoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  needHelp: boolean = true;
  close: boolean = false;
  isParkingLotSeries: boolean = false;
  isParkingLotAccommodateAllTruckType: boolean = false;
  transitionTime = 1017;
  requiredLastNameAsterisk: boolean = false;
  constructor(
    private readonly fb: FormBuilder,
    private readonly apiService: OnboardingServiceService,
    private readonly toastService: ToastService,
    public readonly dialogControlService: DialogControlService,
    private readonly configService: ConfigService
  ) {}

  ngOnInit() {
    const { validators, required } =
      CommonFunctions.getLastNameValidators('parkingAdmin', this.configService);
    this.requiredLastNameAsterisk = required;
    this.ownerForm = this.fb.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN),
          CommonFunctions.noLeadingSpacesValidator(),
        ],
      ],
      lastName: [
        '',
        [
          ...validators,
          Validators.minLength(3),
          Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN),
          CommonFunctions.noLeadingSpacesValidator(),
        ],
      ],
      businessName: ['', [Validators.required, Validators.minLength(3)]],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(EMAIL_VALIDATION_PATTERN),
        ],
      ],
      totalParkingSpace: [
        '',
        [
          Validators.pattern(/^[1-9]\d*$/),
          CustomValidator.validateLessThanThousand,
        ],
      ],
      phone: new FormControl(undefined, [Validators.required]),
      isParkingLotSeries: [],
      isParkingLotAccommodateAllTruckType: [],
    });
    window.scrollTo(0, 0);
  }

  numbersOnlyValidator(event: any) {
    const pattern = /^[0-9\-]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9\-]/g, '');
    }
  }

  toggle() {
    this.close = !this.close;
    this.needHelp = !this.needHelp;

    setTimeout(() => {
      this.needHelp = !this.needHelp;
    }, this.transitionTime);
  }

  openSuccessModal(): void {
    this.dialogControlService.openDialog(CongratsModalComponent, {
      width: '30%',
      data: {
        bodyText: MSG_CONGRATS_PARKING,
      },
    });
  }
  submit() {
    if (this.ownerForm.valid) {
      if (this.ownerForm.value.totalParkingSpace == '') {
        this.ownerForm.value.totalParkingSpace = 0;
      }
      if (this.ownerForm.value.isParkingLotSeries == null) {
        this.ownerForm.value.isParkingLotSeries = false;
      }
      if (this.ownerForm.value.isParkingLotAccommodateAllTruckType == null) {
        this.ownerForm.value.isParkingLotAccommodateAllTruckType = false;
      }

      const request = {
        ownerName: this.ownerForm.value.firstName,
        lastName: this.ownerForm.value.lastName,
        businessName: this.ownerForm.value.businessName,
        email: this.ownerForm.value.email,
        mobileNumber: this.ownerForm.value.phone
          ? this.ownerForm.value.phone.number
          : '',
        totalParkingSpace: this.ownerForm.value.totalParkingSpace,
        isParkingLotSeries: this.ownerForm.value.isParkingLotSeries,
        isParkingLotAccommodateAllTruckType: false,
        countryCode: this.ownerForm.value.phone
          ? this.ownerForm.value.phone.dialCode
          : '',
        iso: this.ownerForm.value.phone
          ? this.ownerForm.value.phone.countryCode
          : '',
      };
      this.apiService
        .saveOnboardingData(request)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: (_response: any) => {
            this.openSuccessModal();
          },
          error: (er: HttpErrorResponse) => {
            this.toastService.showToastMessage(
              'error',
              'Warning',
              er.error.message
            );
          },
        });
    } else {
      CustomValidator.markFormGroupTouched(this.ownerForm);
    }
  }
  onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
}
